export const getUrls = (state) => {
    return state.urls
}